/**
 * React context shape for auth/session state.
 *
 * Kept in its own module (no JSX) so the context object and types can be
 * imported by both the provider component and the consumer hooks without
 * circular `.tsx` dependencies.
 */
import { createContext } from 'react';
export const AuthContext = createContext(null);
//# sourceMappingURL=context.js.map